<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full">
      <template #title>
        <a-row type="flex" align="middle" style="margin-bottom: 10px">
          <a-col :span="8" :md="8"> </a-col>

          <a-col
            :span="16"
            :md="16"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <el-date-picker
              v-model="Query.ym"
              type="month"
              size="mini"
              value-format="yyyyMM"
              placeholder="选择月"
            >
            </el-date-picker>
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="margin-right: 10px; margin-left: 10px"
              @click="SearchClieck()"
            >
              查询
            </a-button>
          </a-col>
        </a-row>
        <a-row type="flex" align="middle" style="margin-bottom: 10px">
          <a-col :span="12" :md="12"> </a-col>
          <a-col
            :span="12"
            :md="12"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
          </a-col>
        </a-row>

        <a-row type="flex" align="top" :gutter="16">
          <a-col :span="24">
            <el-table
              size="medium"
              :data="tableData"
              :stripe="true"
              style="width: 100%; border: 1px solid #e4e7ed"
            >
              <el-table-column prop="infoTime" label="日期"> </el-table-column>
              <el-table-column prop="upTrNum" label="向上行业">
              </el-table-column>
              <el-table-column prop="downTrNum" label="向下行业">
              </el-table-column>
              <el-table-column prop="upStNum" label="向上股票">
              </el-table-column>
              <el-table-column prop="downStNum" label="向下股票">
              </el-table-column>
              <el-table-column prop="upEtfNum" label="向上ETF">
              </el-table-column>
              <el-table-column prop="downEtfNum" label="向下ETF">
              </el-table-column>
              <el-table-column prop="upFuNum" label="向上期货">
              </el-table-column>
              <el-table-column prop="downFuNum" label="向下期货">
              </el-table-column>

              <el-table-column label="详细" width="80">
                <template slot-scope="{ row }">
                  <span class="icon" @click.stop="OpenDetail(row)">
                    <svg
                      t="1763434425676"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="4712"
                      width="32"
                      height="32"
                    >
                      <path
                        d="M85.504 938.688H1024V1024H0v-85.312h0.192V0h85.312v938.688zM128 723.328l212.736-271.552 303.424 155.52L990.912 256v632.64H128v-165.312z"
                        fill="#ffffff"
                        p-id="4713"
                      ></path>
                    </svg>
                  </span>
                </template>
              </el-table-column>
            </el-table>

            <div class="PageCom">
              <el-pagination
                background
                :current-page="Page.index"
                :page-sizes="Page.sizes"
                :page-size="Page.size"
                :total="Page.total"
                layout="sizes, total, prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </a-col>
        </a-row>
      </template>
    </a-card>
  </div>
</template>

<script>
import store from "@/store";
import { getGapList } from "@/api/gap";
export default {
  data() {
    return {
      Query: {
        ym: "",
      },
      tableData: [],
      Page: {
        index: 1,
        size: 10,
        sizes: [10, 50, 100, 200, 500, 1000],
        total: 0,
      },
      isAdmin: store.getters.roles.includes("admin"),
    };
  },
  created() {
    this.GetTableData();

    if (this.isAdmin) {
      this.columns.push({
        title: "操作",
        key: "editBtn",
        scopedSlots: { customRender: "editBtn" },
      });
    }
  },
  methods: {
    handleSizeChange(val) {
      this.Page.size = val;
      this.GetTableData(this.Query);
    },
    handleCurrentChange(val) {
      this.Page.index = val;
      this.GetTableData(this.Query);
    },
    GetTableData() {
      console.log(this.Query.ym);
      if (this.Query.ym == null) {
        this.Query.ym = "";
      }
      getGapList(this.Query.ym, this.Page.index, this.Page.size).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list;
          this.Page.total = res.data.total;
        }
      });
    },
    SearchClieck() {
      this.Page.index = 1;
      this.Page.size = 10;
      this.GetTableData();
    },
    OpenDetail(row) {
      try {
        const fullUrl = row.htmlUrl;
        // 添加防缓存参数
        const timestamp = new Date().getTime();
        const urlWithTimestamp =
          fullUrl + (fullUrl.includes("?") ? "&" : "?") + `t=${timestamp}`;

        const newWindow = window.open(urlWithTimestamp, "_blank");

        if (newWindow === null || typeof newWindow === "undefined") {
          console.warn("新窗口可能被浏览器阻止，尝试使用备选方案");
          window.location.href = urlWithTimestamp;
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  background-color: #1296db;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin: 7px;
  vertical-align: middle;
  cursor: pointer;
}
</style>